export class DiscountOfferItemsFilterEntity {
  id?: number 
  searchWord?: string 
  page?: number 
  limit?: number 
  sortField?: string 
  sortDescending?: boolean 
}